import { render, staticRenderFns } from "./ContactInfo1.vue?vue&type=template&id=6ded0a8a&scoped=true&"
import script from "./ContactInfo1.vue?vue&type=script&lang=js&"
export * from "./ContactInfo1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded0a8a",
  null
  
)

export default component.exports